// import React, { useContext } from 'react'
// import './ProfileCardNew.css'
// import { defaultProfileImage } from '../DefaultImage';
// import { CardContext } from '../../../store/CardContext';

// function ProfileCardNew({ Highlightcolor, Textcolor, profileCardColor, theme }) {
//     const [cardData] = useContext(CardContext)

//     const {
//         profileImage,
//         personalDetails,
//         checkProfile,
//     } = cardData

//     const array = personalDetails?.name ? personalDetails?.name?.split(" ") : "";


//     return (
//         <div className='profileCardNew'>
//             <div
//                 className={`userDetails ${!checkProfile ? "flex flex-col jutify-center" : ""
//                     } ${theme ? "" : 'rounded-xl'}`}
//                 style={{
//                     backgroundColor: `${profileCardColor ? profileCardColor : Highlightcolor ? Highlightcolor : ""}`,
//                     marginBottom: `${theme ? "0" : "30px"}`

//                 }}
//             >
//                 {checkProfile ? (
//                     <figure>
//                         {profileImage ? (
//                             <img
//                                 src={profileImage}
//                                 alt=""
//                             />
//                         ) : (
//                             <img src={defaultProfileImage} alt="" />
//                         )}
//                     </figure>
//                 ) : (
//                     ""
//                 )}
//                 <div
//                     className="user"
//                     style={{ width: `${checkProfile ? "calc(100% - 122px)" : ""}` }}
//                 >
//                     <h1
//                         style={{
//                             color: `${profileCardColor ? "black" : Textcolor ? Textcolor : ""}`,
//                             width: `${!checkProfile ? "max-content" : ""}`,
//                             fontSize: `${array[0]?.length > 12 ||
//                                 array[1]?.length > 12 ||
//                                 array[2]?.length > 12
//                                 ? "16px"
//                                 : (personalDetails?.nameSize ? `${personalDetails?.nameSize}px` : "")
//                                 }`,
//                         }}
//                     >
//                         {" "}
//                         {personalDetails?.name ? personalDetails.name : ""}
//                     </h1>
//                     <p
//                         style={{
//                             color: `${profileCardColor ? "black" : Textcolor ? Textcolor : ""}`,
//                             fontSize: `${personalDetails?.credentialsSize ? personalDetails?.credentialsSize + 'px' : "10px"}`
//                         }}
//                     >
//                         {personalDetails?.credentials
//                             ? personalDetails.credentials
//                             : ""}
//                     </p>
//                     <p
//                         className='pt-2 '
//                         style={{
//                             color: `${profileCardColor ? "black" : Textcolor ? Textcolor : ""}`,
//                             fontSize: `${personalDetails?.designationSize ? personalDetails?.designationSize + 'px' : ""}`
//                         }}
//                     >
//                         {personalDetails?.companyDesignation
//                             ? personalDetails.companyDesignation
//                             : ""}
//                     </p>
//                     <p
//                         style={{
//                             color: `${profileCardColor ? "black" : Textcolor ? Textcolor : ""}`,
//                             fontSize: `${personalDetails?.divisonSize ? personalDetails?.divisonSize + 'px' : "10px"}`
//                         }}
//                     >
//                         {personalDetails?.divison
//                             ? personalDetails.divison
//                             : ""}
//                     </p>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default ProfileCardNew

import React, { useContext } from 'react'
import './ProfileCardNew.css'
import { defaultProfileImage } from '../DefaultImage';
import { CardContext } from '../../../store/CardContext';

function ProfileCardNew({ Highlightcolor, Textcolor, profileCardColor, theme,card }) {
    const [cardData] = useContext(CardContext)

    const {
        profileImage,
        personalDetails,
        checkProfile,
    } = cardData
console.log(personalDetails)
    const array = personalDetails?.name ? personalDetails?.name?.split(" ") : "";


    return (
        <div className='profileCardNew'>
            <div
                className={`userDetails ${!checkProfile ? "flex flex-col jutify-center" : ""
                    } ${theme ? "" : 'rounded-xl'}`}
                style={{
                    backgroundColor: `${profileCardColor ? profileCardColor : Highlightcolor ? Highlightcolor : ""}`,
                    marginBottom: `${theme ? "0" : "30px"}`

                }}
            >
                {checkProfile ? (
                    <figure>
                        {profileImage ? (
                            <img
                                src={profileImage}
                                alt=""
                            />
                        ) : (
                            <img src={defaultProfileImage} alt="" />
                        )}
                    </figure>
                ) : (
                    ""
                )}
                <div
                    className="user"
                    style={{ width: `${checkProfile ? "calc(100% - 100px)" : ""}` }}
                >
                    <h1
                        style={{
                            color: `${profileCardColor ? "black" : Textcolor ? Textcolor : ""}`,
                            width: `${!checkProfile ? "max-content" : ""}`,
                            fontSize: `${array[0]?.length > 12 ||
                                array[1]?.length > 12 ||
                                array[2]?.length > 12
                                ? "16px"
                                : (personalDetails?.nameSize ? `${personalDetails?.nameSize}px` : "")
                                }`,
                        }}
                    >
                        {" "}
                    {personalDetails?.name ? personalDetails.name : ""}
                    </h1>
                    <p
                        style={{
                            color: `${profileCardColor ? "black" : Textcolor ? Textcolor : ""}`,
                            fontSize: `${personalDetails?.credentialsSize ? personalDetails?.credentialsSize + 'px' : "10px"}`
                        }}
                    >
                        {personalDetails?.credentials
                            ? personalDetails.credentials
                            : ""}
                    </p>
                    <p
                        className='pt-2 '
                        style={{
                            color: `${profileCardColor ? "black" : Textcolor ? Textcolor : ""}`,
                            fontSize: `${personalDetails?.designationSize ? personalDetails?.designationSize + 'px' : ""}`
                        }}
                    >
                        {personalDetails?.companyDesignation
                            ? personalDetails.companyDesignation
                            : ""}
                    </p>
<p
  style={{
    color: `${profileCardColor ? "black" : Textcolor ? Textcolor : ""}`,
  }}
>
 {personalDetails?.companyName || cardData?.companyName || cardData?.otherFields?.companyName}
</p>       

                    <p
                        style={{
                            color: `${profileCardColor ? "black" : Textcolor ? Textcolor : ""}`,
                            fontSize: `${personalDetails?.divisonSize ? personalDetails?.divisonSize + 'px' : "10px"}`
                        }}
                    >
                        {personalDetails?.divison
                            ? personalDetails.divison
                            : ""}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ProfileCardNew